/**
 * События для WebView → Firebase Analytics (и др.).
 *
 * Формат payload:
 * { type: 'analytics', event, params, timestamp, sessionId, user }
 *
 * Native:
 * - iOS: window.webkit.messageHandlers.lfAnalytics.postMessage(payload)
 * - RN:  window.ReactNativeWebView.postMessage(JSON.stringify(payload))
 * - Android: window.LFNative.postMessage(json) или window.Android.onAnalyticsEvent(json)
 * - Универсально: window.addEventListener('lf:analytics', e => …)
 * - Хук: window.LFAnalytics.onEvent = (payload) => …
 */
export const Events = {
  // Lifecycle
  APP_OPEN: 'app_open',
  PAGE_VIEW: 'page_view',

  // Onboarding
  ONBOARDING_STARTED: 'onboarding_started',
  ONBOARDING_STEP: 'onboarding_step',
  ONBOARDING_SKIPPED: 'onboarding_skipped',
  ONBOARDING_COMPLETED: 'onboarding_completed',

  // Paywall / checkout
  PAYWALL_VIEWED: 'paywall_viewed',
  PAYWALL_DISMISSED: 'paywall_dismissed',
  CHECKOUT_STARTED: 'checkout_started',
  CHECKOUT_CANCELED: 'checkout_canceled',
  CHECKOUT_SUCCESS: 'checkout_success',
  CHECKOUT_FAILED: 'checkout_failed',
  CONTENT_LOCK_VIEWED: 'content_lock_viewed',
  PAYWALL_GATE_SHOWN: 'paywall_gate_shown',
  PAYWALL_GATE_CTA: 'paywall_gate_cta',
  PAYWALL_GATE_DISMISSED: 'paywall_gate_dismissed',

  // Match / stream
  MATCH_OPENED: 'match_opened',
  MATCH_VIEWED: 'match_viewed',
  MATCH_STARRED: 'match_starred',
  MATCH_UNSTARRED: 'match_unstarred',
  STREAM_PLAY_ATTEMPT: 'stream_play_attempt',
  STREAM_STARTED: 'stream_started',
  STREAM_ERROR: 'stream_error',
  STREAM_CHANNEL_SWITCH: 'stream_channel_switch',
  STREAM_FULLSCREEN: 'stream_fullscreen',

  // Navigation / UI
  NAV_CLICK: 'nav_click',
  LOCALE_CHANGED: 'locale_changed',
  HOME_FILTER_CHANGED: 'home_filter_changed',
  HOME_PAGINATION: 'home_pagination',
  LOBBY_TILE_CLICK: 'lobby_tile_click',

  // Account
  ACCOUNT_VIEWED: 'account_viewed',
  SESSION_RESET: 'session_reset',
  SUBSCRIPTION_ACTIVATED: 'subscription_activated',

  // Funnel
  FUNNEL_MODE_RESOLVED: 'funnel_mode_resolved'
};

export default Events;
